export default __webpack_public_path__ + "static/media/Cuvette_lid.b2f6d0b9.svg";